import { SectorMap } from './SectorMap';
import { Rectangle } from '../../Geometry';
import { TreemapCalculator } from '../TreeMap/TreemapCalculator';
export class MapContainer {
    get isEmpty() {
        return this._sectorMapList.length === 0;
    }
    get isVisible() {
        return this._sectorMapList.some((sector) => sector.Visible);
    }
    get sectorHeaderHeight() {
        return this._sectorHeaderHeight;
    }
    get industryHeaderHeight() {
        return this._industryHeaderHeight;
    }
    constructor(partialIntervalManager) {
        this._sectorHeaderHeight = 32;
        this._industryHeaderHeight = 24;
        this._sectorMapList = [];
        this._data = [];
        this._partialIntervalManager = partialIntervalManager;
    }
    Populate(heatmapData) {
        this.clearMap();
        this._data = heatmapData;
        const grouped = this._data.reduce((accumulator, currentValue) => {
            (accumulator[currentValue.sector] = accumulator[currentValue.sector] || []).push(currentValue);
            return accumulator;
        }, {});
        for (const group in grouped) {
            this._sectorMapList.push(new SectorMap(this, group, grouped[group]));
        }
    }
    getData() {
        return this._data;
    }
    getSectorMapList() {
        return this._sectorMapList;
    }
    getIndustryMapList() {
        const list = [];
        for (const sector of this.getSectorMapList()) {
            for (const industry of sector.items) {
                list.push(industry);
            }
        }
        return list;
    }
    getSymbolMapList() {
        const list = [];
        for (const industry of this.getIndustryMapList()) {
            for (const symbol of industry.items) {
                list.push(symbol);
            }
        }
        return list;
    }
    getSymbolBackgroundColor(changePerWeight) {
        let weight = changePerWeight;
        if (isNullOrUndefined(changePerWeight)) {
            weight = 0;
        }
        if (this._partialIntervalManager.count === 0 || weight === 0) {
            return this._partialIntervalManager.getDefaultColor();
        }
        for (const interval of this._partialIntervalManager.getIntervals()) {
            if (interval.contains(weight)) {
                return interval.LeftColor;
            }
        }
        return this._partialIntervalManager.getDefaultColor();
    }
    updateMap(width, height, sectorHeaderHeight, industryHeaderHeight) {
        this._sectorHeaderHeight = sectorHeaderHeight;
        this._industryHeaderHeight = industryHeaderHeight;
        this.updateVisibility();
        this.recalculateArea(new Rectangle(0, 0, width, height));
    }
    clearMap() {
        this._sectorMapList.length = 0;
        this._data.length = 0;
    }
    selectSector(sector) {
        for (const sectorMap of this._sectorMapList) {
            sectorMap.isSelected = sectorMap === sector;
            sectorMap.isHidden = sectorMap !== sector;
        }
    }
    selectIndustry(industry) {
        for (const sectorMap of this._sectorMapList) {
            for (const industryMap of sectorMap.items) {
                industryMap.isSelected = industryMap === industry;
                industryMap.isHidden = industryMap !== industry;
            }
        }
    }
    clearSelection() {
        for (const sectorMap of this._sectorMapList) {
            sectorMap.isSelected = false;
            sectorMap.isHidden = false;
            for (const industryMap of sectorMap.items) {
                industryMap.isSelected = false;
                industryMap.isHidden = false;
            }
        }
    }
    updateVisibility() {
        const allIntervals = this._partialIntervalManager.getIntervals();
        const selectedIntervals = this._partialIntervalManager.getSelectedIntervals();
        const isAllInvisible = selectedIntervals.length === 0;
        const isAllVisible = allIntervals.length === selectedIntervals.length;
        const sectorMap = this._sectorMapList;
        for (let sectorIndex = 0; sectorIndex < sectorMap.length; sectorIndex++) {
            const sector = sectorMap[sectorIndex];
            for (let industryIndex = 0; industryIndex < sector.items.length; industryIndex++) {
                const industry = sector.items[industryIndex];
                for (let symbolIndex = 0; symbolIndex < industry.items.length; symbolIndex++) {
                    const symbol = industry.items[symbolIndex];
                    if (isNullOrUndefined(symbol.heatmapData) || isNullOrUndefined(symbol.heatmapData.changePercent)) {
                        continue;
                    }
                    if (isAllInvisible || sector.isHidden || industry.isHidden) {
                        symbol.Visible = false;
                        continue;
                    }
                    if (isAllVisible) {
                        symbol.Visible = true;
                        continue;
                    }
                    let isVisible = false;
                    for (let selectedIntervalIndex = 0; selectedIntervalIndex < selectedIntervals.length; selectedIntervalIndex++) {
                        const interval = selectedIntervals[selectedIntervalIndex];
                        if (interval.contains(symbol.heatmapData.changePercent)) {
                            isVisible = true;
                            break;
                        }
                    }
                    symbol.Visible = isVisible;
                }
            }
        }
    }
    recalculateArea(areaRectangle) {
        const treemapContainer = new TreemapCalculator();
        const list = this._sectorMapList;
        const visibleList = list.filter((y) => y.Visible);
        treemapContainer.recalculate(visibleList, areaRectangle);
        for (const sector of visibleList) {
            sector.recalculateArea();
        }
    }
}
